"use client";

import { createContext, use } from "react";

import { SourcesResponse } from "@/entities/source/lib/api/viewbox-source/types.js";

const SourcesContext = createContext<SourcesResponse | null>(null);

export const SourcesProvider = ({
  sources,
  children,
}: React.PropsWithChildren<{ sources: SourcesResponse }>) => {
  return (
    <SourcesContext.Provider value={sources}>
      {children}
    </SourcesContext.Provider>
  );
};

export const useSources = () => {
  return use(SourcesContext)!;
};
